export enum DataGridPermissionKeysEnum {
  CUSTOM_SHARE_PRESET = 'customSharePreset',
}
